import type { DecisionEngineDestinationUI } from "./definition";

export const sfmcTriggerUI: DecisionEngineDestinationUI = {
  campaignSetup: "template",
  resourceName: "template",
  channelDescription: "SFMC (Trigger)",
  getReferenceString: (s) => `%%=v(AttributeValue("${s}"))=%%`,
  getResourceUrl: (resource, _destinationConfig, channel) => {
    if (channel.type === "email") {
      return "https://mc.exacttarget.com/cloud/#app/Email/C12/Default.aspx?entityType=none&entityID=0&ks=ks%23Interactions";
    }
    return `https://mc.exacttarget.com/cloud/#app/MobilePush/mobilepush/%23!/message/view/${resource.id}`;
  },
  isInactive: (resource) => resource.status !== "active",
  isPreviewSupported: true,
  getTemplateResourceType: ({ type }) => `${type}-template`,
  getResourceType: ({ type }) =>
    type === "email" ? "triggered-send-definition" : "push-template",
  getEmailPreviewMethod: "e2e",
  isTestSendSupported: true,
  getCustomVariables: ({ type }) => (type === "push" ? ["subtitle"] : []),
};

export const sfmcJourneyUI: DecisionEngineDestinationUI = {
  campaignSetup: "event-triggered",
  resourceName: "journey",
  channelDescription: "SFMC (Journey)",
  getReferenceString: (s) => {
    const split = s.split(".");
    const type = split[1];
    const withoutPrefix =
      type === "user" ? split.slice(2).join(".") : split.slice(3).join(".");
    return `%%=v(AttributeValue("${withoutPrefix}"))=%%`;
  },
  getResourceUrl: () =>
    "https://mc.exacttarget.com/cloud/#app/Journey%20Builder",
  isInactive: (resource) => resource.status !== "active",
  isPreviewSupported: true,
  getTemplateResourceType: () => "entry-event-definition",
  getResourceType: () => "journey",
  getEmailPreviewMethod: "preview",
  isTestSendSupported: true,
  isIdentifierReadonly: true,
  showAssociatedTemplate: true,
};

export const sfmcDataExtensionsUI: DecisionEngineDestinationUI = {
  campaignSetup: "freeform",
  resourceName: "automation",
  channelDescription: "SFMC (Automation)",
  getReferenceString: (s) => `%%=v(AttributeValue("${s}"))=%%`,
  isInactive: (resource) => resource.status !== "active",
  isPreviewSupported: false,
  getResourceType: ({ type }) => {
    const map: Record<string, string> = {
      email: "email-template",
      inapp: "inapp-template",
      push: "push-template",
      sms: "sms-template",
    };
    return map[type] ?? "";
  },
  getEmailPreviewMethod: "e2e",
  isTestSendSupported: (channelConfig) =>
    !channelConfig.useLegacyDataExtension &&
    channelConfig.syncMode !== "mirror",
  isIdentifierReadonly: true,
  showAssociatedTemplate: (channelConfig) =>
    !channelConfig.useLegacyDataExtension,
};
